import { render, staticRenderFns } from "./selectCom.vue?vue&type=template&id=66f72421&scoped=true&"
import script from "./selectCom.vue?vue&type=script&lang=js&"
export * from "./selectCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f72421",
  null
  
)

export default component.exports